import { UNREAD_NOTIFICATIONS_COUNT_SUCCESS } from 'constants/action-types/loanRequests/microLoanNotifications';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';

export default () => dispatch =>
  dispatch(
    apiAction({
      url: `/user/notifications/admin-requests/unread-count`,
      method: 'GET',
      API_REQUEST_SUCCESS: UNREAD_NOTIFICATIONS_COUNT_SUCCESS,
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
